import { BenefitsCard } from "@components/WACardWrappers";
import { isJSXElement } from "@utils/common";
import React from "react";
import { IconType } from "react-icons/lib";
import Image from "next/image";
interface BenefitsPanelProps {
    mainTitle?: string | JSX.Element;
    mainDescription?: string;
    cardContent: BenefitsCardContentProps[];
    iconStyle?: string;
    isArabic?: boolean;
    variant?: "light" | "blue";
}

export interface BenefitsCardContentProps {
    imageUrl?: any;
    icon?: IconType;
    title: string;
    description: string;
}

const getCardStyle = (isArabic: boolean, variant: "light" | "blue"): React.CSSProperties => ({
    textAlign: "start",
    padding: "24px",
    backgroundColor: variant === "blue" ? "rgba(43, 85, 213, 1)" : "#FFFF",
    justifyContent: "flex-start",
    alignItems: isArabic ? "flex-end" : "flex-start",
});

const BenefitsPanel: React.FC<BenefitsPanelProps> = (props) => {
    const { mainTitle, mainDescription, cardContent, iconStyle, isArabic = false, variant = "light" } = props;
    const cardContentLength = cardContent.length;
    const isBlue = variant === "blue";
    const cardStyle = getCardStyle(isArabic, variant);

    const titleColorClass = isBlue ? "text-white" : "text-gray-600";
    const descriptionColorClass = isBlue ? "text-gray-100" : "text-gray-600";

    return (
        <div className="lg:mx-auto md:mx-4 max-w-6xl flex flex-col lg:gap-10 gap-6 items-center">
            {mainTitle && (isJSXElement(mainTitle) ? mainTitle : <h3 className="text-3xl text-gray-900 font-bold text-center">{mainTitle}</h3>)}
            {mainDescription && <p className="text-base text-gray-500 font-normal text-center">{mainDescription}</p>}
            <div className="flex lg:flex-row flex-col lg:gap-8 gap-6">
                {cardContent.map((cardContent, index) => (
                    <div key={index} className={`lg:w-1/${cardContentLength} md:max-w-sm w-fit lg:mx-0 md:mx-10 mx-3`}>
                        <BenefitsCard className="h-full" style={cardStyle}>
                            {cardContent.icon && (
                                <div className={`bg-blue-500 ${iconStyle ? iconStyle : "rounded-xl"} w-12 h-12 flex items-center justify-center`} style={{ color: "white" }}>
                                    <cardContent.icon size="30px" />
                                </div>
                            )}
                            {cardContent.imageUrl && (
                                <div className={`p-0 rounded-full ${isBlue ? "bg-white" : "bg-blue-500"}`}>
                                    <Image width={38} height={38} src={cardContent.imageUrl} alt={cardContent.title} />
                                </div>
                            )}
                            <div className={`flex flex-col gap-4 ${isArabic ? "text-right" : "text-left"}`}>
                                {cardContentLength === 3 && <h5 className={`text-2xl ${titleColorClass} font-bold flex`}>{cardContent.title}</h5>}
                                {cardContentLength === 4 && <h5 className={`text-base font-bold ${titleColorClass}`}>{cardContent.title}</h5>}
                                <p className={`text-base ${descriptionColorClass} font-normal ${isArabic ? "text-right" : "text-left"}`}>{cardContent.description}</p>
                            </div>
                        </BenefitsCard>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BenefitsPanel;
